import '../../../../overlays/modal/Modal.css';
import './DataTableSettingsModal.css';
export var footer = {'default':'_115i8c20-3-8-0',withMessage:'_115i8c21-3-8-0'};